import { Http, Response, URLSearchParams } from '@angular/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {  PolicyDetailsVM } from '../entities/global/model';


@Injectable()
export class PolicyProcedureService {

  constructor(private _http: Http) { }

  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
}

  public getPolicyProcedureDetail(PolicyId: number): Observable<PolicyDetailsVM> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('PolicyId', PolicyId.toString());
    return this._http.get('Api/PolicyProcedure/getPolicyProcedureDetail', { search: params }).share().map(
        (response: Response) => <PolicyDetailsVM>response.json()).catch(this.handleError);
  }

  public savePolicyProcedure(existingTemplate: PolicyDetailsVM): Observable<number> {
    return this._http.post("api/PolicyProcedure/SavePolicyProcedure", existingTemplate).share().map(
        (response: Response) => <number>response.json()).catch(this.handleError);
  }

  public updatePolicyProcedure(existingTemplate: PolicyDetailsVM): Observable<number> {
    return this._http.post("api/PolicyProcedure/UpdatePolicyProcedure", existingTemplate).share().map(
        (response: Response) => <number>response.json()).catch(this.handleError);
  }

  public searchPolicyProcedureDetails(searchFields: PolicyDetailsVM): Observable<PolicyDetailsVM[]> {
    return this._http.post("api/PolicyProcedure/SearchPolicyProcedures", searchFields).share().map(
        (response: Response) => <PolicyDetailsVM[]>response.json()).catch(this.handleError);
  } 

}
